"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxSkeleton = void 0;
var buffer_1 = require("buffer");
var lodash_1 = require("lodash");
var Serialization_1 = require("../Handlers/Serialization");
var Output_1 = require("./Types/Output");
var Input_1 = require("./Types/Input");
var TxSkeleton = /** @class */ (function () {
    function TxSkeleton(inputs, outputs) {
        this.inputs = inputs;
        this.outputs = outputs;
    }
    TxSkeleton.read = function (buffer, offset) {
        var _a = Serialization_1.readVarInt(buffer, offset), inputsLength = _a.value, tempOffset = _a.offset;
        offset = tempOffset;
        var inputs = [];
        for (var i = 0; i < inputsLength; i++) {
            var _b = Input_1.Input.read(buffer, offset, true), input = _b.input, inputOffset = _b.offset;
            inputs.push(input);
            offset = inputOffset;
        }
        var _c = Serialization_1.readVarInt(buffer, offset), outputsLength = _c.value, tempOffset2 = _c.offset;
        offset = tempOffset2;
        var outputs = [];
        for (var i = 0; i < outputsLength; i++) {
            var _d = Output_1.Output.read(buffer, offset), output = _d.output, outputOffset = _d.offset;
            outputs.push(output);
            offset = outputOffset;
        }
        var tx = new TxSkeleton(inputs, outputs);
        return { tx: tx, offset: offset };
    };
    TxSkeleton.fromHex = function (hex) {
        var buffer = buffer_1.Buffer.from(hex, 'hex');
        var tx = TxSkeleton.read(buffer, 0).tx;
        return tx;
    };
    TxSkeleton.prototype.getSize = function () {
        var inputsSize = Serialization_1.getSizeOfVarInt(this.inputs.length) +
            lodash_1.sumBy(this.inputs, function (input) { return input.getSize(); });
        var outputsSize = Serialization_1.getSizeOfVarInt(this.outputs.length) +
            lodash_1.sumBy(this.outputs, function (output) { return output.getSize(); });
        return inputsSize + outputsSize;
    };
    TxSkeleton.prototype.write = function (buffer, offset) {
        offset = Serialization_1.writeVarInt(this.inputs.length, buffer, offset);
        this.inputs.forEach(function (input) { return offset = input.write(buffer, offset); });
        offset = Serialization_1.writeVarInt(this.outputs.length, buffer, offset);
        this.outputs.forEach(function (output) { return offset = output.write(buffer, offset); });
    };
    TxSkeleton.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = buffer_1.Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    TxSkeleton.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    TxSkeleton.prototype.toJson = function () {
        return {
            inputs: this.inputs.map(function (input) { return input.toJson(); }),
            outputs: this.outputs.map(function (output) { return output.toJson(); }),
        };
    };
    return TxSkeleton;
}());
exports.TxSkeleton = TxSkeleton;
//# sourceMappingURL=TxSkeleton.js.map